import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "actionsMenu",
  class: "user-actions-menu",
  role: "navigation"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('cwx-icon cwx-icon-after_close mobile-modal__close-btn'),
  type: 'button'
}
const _hoisted_5 = {
  key: 3,
  class: "header-bar__hamburger"
}
const _hoisted_6 = {
  key: 0,
  class: "mobile-modal__top"
}

import { ref } from 'vue';
import UserProfileMenu from '@/components/userArea/UserProfileMenu.vue';
import { Popup } from '@progress/kendo-vue-popup';
import { BadgeContainer as kBadgeContainer } from '@progress/kendo-vue-indicators';
import { onClickOutside, useMagicKeys, whenever } from '@vueuse/core';
import UserSearchBox from '@/components/userArea/UserSearchBox.vue';
import { useAppStore } from '@/stores/app.store';
import { useUserStore } from '@/stores/user.store';
import { useNavigationStore } from '@/stores/navigation.store';
import { animationSetting } from '@/constants/globalKendoConfig';
import MegaMenuMobile from '@/components/common/megaMenu/MegaMenuMobile.vue';
import useTranslations from '@/composables/useTranslations';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAreaActionsMenu',
  setup(__props) {

const userStore = useUserStore();
const appStore = useAppStore();
const navigationStore = useNavigationStore();
const userProfile = ref();
const userProfilePopup = ref();
const isUserProfileMenuOpen = ref(false);
const isMobileMenuVisible = ref(false);
const searchBar = ref();
const searchBarPopup = ref();
const isSearchBarOpen = ref(false);
const keys = useMagicKeys();
const { translate: t } = useTranslations();
onClickOutside(userProfilePopup, () => handleClickOutsideUserProfileMenu(), {
  ignore: [userProfile],
});
onClickOutside(searchBarPopup, () => handleClickOutsideSearchBar(), { ignore: [searchBar] });

function handleSearchBtnClick() {
  isSearchBarOpen.value = false;
}

function handleClickUserAvatar() {
  isMobileMenuVisible.value = false;
  isUserProfileMenuOpen.value = !isUserProfileMenuOpen.value;
}

function handleClickHamburgerMenu() {
  isUserProfileMenuOpen.value = false;
  isMobileMenuVisible.value = !isMobileMenuVisible.value;
}

function handleClickOutsideUserProfileMenu() {
  isUserProfileMenuOpen.value = false;
}

function handleClickSearchIcon() {
  isSearchBarOpen.value = !isSearchBarOpen.value;
}

function handleClickOutsideSearchBar() {
  isSearchBarOpen.value = false;
}

whenever(keys.escape, () => {
  if (isSearchBarOpen.value) {
    isSearchBarOpen.value = false;
    searchBarPopup.value.$el.blur();
  }

  if (isUserProfileMenuOpen.value) {
    isUserProfileMenuOpen.value = false;
    userProfile.value.$el.blur();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      (_unref(navigationStore).userTopMenu?.topSearchBoxVisible && !_unref(appStore)?.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "searchBar",
            ref: searchBar,
            class: _normalizeClass([{ active: isSearchBarOpen.value }, "cwx-icon cwx-icon-after_zoom"]),
            role: "button",
            tabindex: "0",
            "aria-label": _unref(t)('Search'),
            onClick: handleClickSearchIcon,
            onKeyup: _withKeys(handleClickSearchIcon, ["enter"])
          }, [
            _createVNode(_unref(Popup), {
              ref_key: "searchBarPopup",
              ref: searchBarPopup,
              anchor: 'searchBar',
              "anchor-align": { horizontal: 'right', vertical: 'bottom' },
              animate: true,
              "popup-align": { horizontal: 'right', vertical: 'top' },
              "popup-class": 'popup',
              show: isSearchBarOpen.value,
              class: "user-actions-menu__search-popup"
            }, {
              default: _withCtx(() => [
                _createVNode(UserSearchBox, { onSearchClicked: handleSearchBtnClick })
              ]),
              _: 1
            }, 8, ["show"])
          ], 42, _hoisted_2))
        : _createCommentVNode("", true),
      (_unref(navigationStore)?.userTopMenu?.topSubmitButtonVisible)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: _unref(navigationStore)?.userTopMenu?.topSubmitButtonUrl,
            tabindex: "0",
            "aria-label": "Submit your information"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "cwx-icon cwx-icon-after_file-add" }, null, -1)
          ]))], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_unref(kBadgeContainer), {
        ref_key: "userProfile",
        ref: userProfile,
        content: 'content',
        align: { horizontal: _unref(appStore).dir == 'rtl' ? 'start' : 'end', vertical: 'bottom' },
        class: _normalizeClass([{ active: isUserProfileMenuOpen.value }, "user-actions-menu__user-avatar ccc"]),
        "fill-mode": 
        _unref(userStore)?.userSettings?.hasNotifications ? 'solid' : (null as unknown as undefined)
      ,
        rounded: 'full',
        "data-testid": "user-profile-menu",
        tabindex: "0",
        role: "button",
        "aria-haspopup": "true",
        "aria-label": _unref(t)('Menu.UserProfileSettings'),
        onClick: handleClickUserAvatar,
        onKeyup: _withKeys(handleClickUserAvatar, ["enter"])
      }, {
        default: _withCtx(() => [
          (_unref(appStore)?.isMobile && isUserProfileMenuOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cwx-icon cwx-icon-after_profile-default" }, null, -1))
        ]),
        _: 1
      }, 8, ["align", "class", "fill-mode", "aria-label"]),
      (!_unref(appStore)?.isMobile)
        ? (_openBlock(), _createBlock(_unref(Popup), {
            key: 2,
            ref_key: "userProfilePopup",
            ref: userProfilePopup,
            anchor: 'userProfile',
            "anchor-align": { horizontal: 'right', vertical: 'bottom' },
            animate: _unref(animationSetting),
            "popup-align": { horizontal: 'right', vertical: 'top' },
            "popup-class": 'popup user-actions-menu__user-profile-menu-popup',
            show: isUserProfileMenuOpen.value
          }, {
            default: _withCtx(() => [
              _createVNode(UserProfileMenu, { "is-open": isUserProfileMenuOpen.value }, null, 8, ["is-open"])
            ]),
            _: 1
          }, 8, ["animate", "show"]))
        : _createCommentVNode("", true),
      (_unref(appStore)?.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(
          !isMobileMenuVisible.value
            ? 'cwx-icon cwx-icon-after_menu'
            : 'cwx-icon cwx-icon-after_close mobile-modal__close-btn'
        ),
              role: "button",
              tabindex: "0",
              onKeyup: _cache[0] || (_cache[0] = _withKeys(() => handleClickHamburgerMenu(), ["enter"])),
              onClick: _cache[1] || (_cache[1] = () => handleClickHamburgerMenu())
            }, null, 34),
            (isMobileMenuVisible.value)
              ? (_openBlock(), _createBlock(MegaMenuMobile, {
                  key: 0,
                  "mega-menu-items": _unref(navigationStore)?.userTopMenu.menuItemViewModels || [],
                  onCloseMobileMenu: _cache[2] || (_cache[2] = () => (isMobileMenuVisible.value = false))
                }, null, 8, ["mega-menu-items"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      (_unref(appStore)?.isMobile && isUserProfileMenuOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(UserProfileMenu, { "is-open": isUserProfileMenuOpen.value }, null, 8, ["is-open"])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})